import { render, staticRenderFns } from "./ShowCampaignBannersModal.vue?vue&type=template&id=d885e534&"
import script from "./ShowCampaignBannersModal.vue?vue&type=script&lang=js&"
export * from "./ShowCampaignBannersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports